module.exports = __webpack_public_path__ + "static/media/calculator.b2acfc55.png";